import React from "react";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import "./NewGroupBanner.css";
import TextTheme from "components/General/Text/TextTheme";
import * as CONSTANT from "constants/text";

function NewGroupBanner(props) {
  return (
    <div className="page_details_content_main">
      <div className="new_group_container">
        <div>
          <TextTheme
            message={CONSTANT.START_NEW_GROUP}
            className="textHeader"
          />
          <TextTheme
            message={CONSTANT.NEW_GROUP_BANNER_MESSAGE}
            className={"text_xsmall text_med_grey"}
          />
        </div>

        <div className="start_new_action_button_container">
          <div className="text-right start_new_action_button">
            <RoundedButton
              margin = "0"
              float = "right"
              width = "100px"
              title={CONSTANT.LETS_GO}
              textThemeClassName="text_small text_white text_bold"
              buttonClassName="background_dark_orange"
              handleOnClick={() => (props.history.push("groups/start-new-group/"))}
              className="group_button"
              borderRadius="6px"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewGroupBanner;
